import { useQuery, UseQueryOptions } from 'react-query'

import request from '../../config/axios'
import queryClient from '../../config/react-query'
// import { useUser } from '../auth/AuthContext'
import QueryKeys from './QueryKeys'

interface TableauToken {
  workbookUrl: string
  section?: string
  id?: string
}

interface TableauTokenResponse {
  tableauToken: string
}

const useTableauToken = (
  { workbookUrl, section, id }: TableauToken,
  extraOptions: UseQueryOptions = {},
) => {
  const url = `/accesses/tableau_token`
  const typeParam = section ? section : 'default'
  const key = QueryKeys.tableauToken(typeParam, workbookUrl, id)

  return useQuery(
    key,
    () =>
      request
        .get<TableauTokenResponse>(url, {
          params: {
            // study_id: currentStudyId,
            id: id,
            type: typeParam,
          },
        })
        .then((r) => {
          queryClient.invalidateQueries(
            QueryKeys.tableauToken(typeParam, workbookUrl, id),
          )
          return r.data.tableauToken
        }),
    {
      ...extraOptions,
      // staleTime: 0,
      // cacheTime: 0,
      // refetchInterval: 0,
    },
  )
}

export default useTableauToken
